<template>
<div>
  <v-progress-linear v-show="load" :indeterminate="true" />

  <v-main class="pt-2">
    <v-layout row wrap>

      <v-flex xs6 sm6 lg6 class="pr-1">
        <!-- <v-btn color="success" @click="getHora(10)">Success</v-btn> -->
        <apexcharts id="chartExameExpecialidade" type="line" height="350" :options="chartOptions" :series="series" />
      </v-flex>
      <v-divider vertical />
      <v-flex xs5 sm5 lg5>
        <!-- <v-btn color="success" @click="getHora(10)">Success</v-btn> -->

          <div class="example pt-5">
            <apexcharts v-if="seriesConsultas.length > 0" id="chartOptionTotalConsultas" type="pie" height="250" :options="chartOptionTotalConsultas" :series="seriesConsultas" />
          </div>

      </v-flex>
      <v-flex md12 class="text-center">
          <v-divider />
          <v-card-text >
            <div class="headline">
              Liberação por hora
            </div>
          </v-card-text>

      </v-flex>

    </v-layout>

  </v-main>
</div>
</template>

<script>
import administradorUnidadeService from './../../../services/administradorUnidade.service'
import {
  EventBus
} from './../../../main'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ExameEspecialidade',
  components: {
    apexcharts: VueApexCharts
  },

  props: {
    exameEspecialidade: {
      type: Object
    }
  },

  data () {
    return {
      senhasGeradas: [],
      quantatendimentosStatus: [],
      textTempoAtualizado: '',
      intervalRegistroSocket: '',
      exames: [],
      load: 0,
      consultasHora: [],
      series: [],
      chartOptions: {
        chart: {
          redrawOnParentResize: true,
          id: 'chartExameExpecialidade',
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'straight'
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + ''
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: ['6h', '7h', '8h', '9h', '10h', '11h', '12h', '13h', '14h',
            '15h', '16h', '17h'
          ]
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      seriesConsultas: [],
      chartOptionTotalConsultas: {
        chart: {
          redrawOnParentResize: true,
          id: 'chartOptionTotalConsultas',
          width: 380,
          type: 'pie'
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      arrayChartSenhasGeradas: [],
      chartSenhasGeradas: null,
      chartAtendimentoStatus: null,
      dadosGrafico: []
    }
  },
  mounted () {
    console.log('em servicos unidade...')
    this.user = this.$store.getters.usuario
    // EventBus.$on('carregarTempoEspera', this.carregarTempoEspera)
    // EventBus.$on('carregarDados', this.carregarDadosTabelas)
    // this.carregarDadosTabelas()
    if (this.exameEspecialidade) {
      this.getExpecialidadeHora()
    }
  },
  created () {
    console.log('created...')
  },

  methods: {

    formatarTempo (tempo) {
      var a = tempo.split(':')
    },
    carregarTempoEspera (tempoEspera) {
      this.tempoEspera = tempoEspera
    },

    carregarDadosTabelas (date1, date2) {
      this.retornarExameExpecialidadeHora(date1, date2)
    },

    getExpecialidadeHora () {
      if (this.exameEspecialidade.consultasHora && this.exameEspecialidade.consultasHora.length > 0) {
        this.graficoConsultaHoras(this.exameEspecialidade.consultasHora)
      }
      if (this.exameEspecialidade.quantTotalConsultas && this.exameEspecialidade.quantTotalConsultas.length > 0) {
        this.graficoTotalConsulta(this.exameEspecialidade.quantTotalConsultas)
      }
    },
    retornarExameExpecialidadeHora_ (date1, date2) {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .retornarExameEspexialidadeHora(date1, date2)
        .then((rsp) => {
          console.log('retornarExameEspexialidadeHora', rsp.data)
          if (rsp.data.consultasHora && rsp.data.consultasHora.length > 0) {
            this.graficoConsultaHoras(rsp.data.consultasHora)
          }
          if (rsp.data.quantTotalConsultas && rsp.data.quantTotalConsultas.length > 0) {
            this.graficoTotalConsulta(rsp.data.quantTotalConsultas)
          }
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch((err) => {
          // handle your error
          this.loadingTabela1 = false
          console.log(err)
        })
    },
    graficoConsultaHoras (lista) {
      console.log('graficoConsultaHoras')
      let series = []
      lista.forEach((e, i, err) => {
        series[i] = e
      })
      this.series = series
      ApexCharts.exec('chartExameExpecialidade', 'updateSeries', series, true)
    },

    graficoTotalConsulta (lista) {
      let series = []
      let titulos = []
      console.log(lista)
      lista.forEach((e, i, err) => {
        // console.log('teste -> ', e)
        series[i] = e.data
        titulos[i] = e.name
      })
      this.seriesConsultas = series
      this.chartOptionTotalConsultas.labels = titulos
      ApexCharts.exec('chartOptionTotalConsultas', 'updateOptions', {
        labels: titulos
      }, true)
      ApexCharts.exec('chartOptionTotalConsultas', 'updateSeries', series, true)
    },
    converterDate (data) {
      if (data == '---') {
        return '---'
      } else {
        var d = new Date(data)
        var dia = d.getDate().toString()
        var diaF = dia.length == 1 ? '0' + dia : dia
        var mes = (d.getMonth() + 1).toString() // +1 pois no getMonth Janeiro começa com zero.
        var mesF = mes.length == 1 ? '0' + mes : mes
        var anoF = d.getFullYear()

        return diaF + '/' + mesF + '/' + anoF
      }
    }
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
